import React, { Component } from 'react'
import hasGridInformation from '../../hoc/hasGridInformation'
import hasToggleMovieDatesOnMobile from '../../hoc/hasToggleMovieDatesOnMobile'
import { trackMovieInformationOpen } from '../../tracking'
import { getItemsWithInterscroller } from '../../functions/weischerHelpers'
import getMovieLink from '../../functions/getMovieLink'
import GridMovieInformation from '../FilterResultsGrid/GridMovieInformation'
import GridTrailerItems from './GridTrailerItems'


class FilterResultsGridTrailer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            startPlayTrailersIntervallId: false,
            playTrailerIems: {},
        }

        this.playTrailerAfter = 1400

        this.setTrailerItemsInView = this.setTrailerItemsInView.bind(this)
        this.startPlayTrailers = this.startPlayTrailers.bind(this)
        this.playTrailer = this.playTrailer.bind(this)
    }

    componentDidMount() {
        this.startPlayTrailers()

        this.debouncedStartPlayTrailers =  _.debounce(this.startPlayTrailers, 300)
        window.addEventListener("resize",  this.debouncedStartPlayTrailers)
        window.addEventListener("scroll",  this.debouncedStartPlayTrailers)
    }

    componentWillUnmount() {
        const { startPlayTrailersIntervallId } = this.state

        this.debouncedStartPlayTrailers.cancel()
        window.removeEventListener("resize", this.debouncedStartPlayTrailers)
        window.removeEventListener("scroll", this.debouncedStartPlayTrailers)

        startPlayTrailersIntervallId && clearInterval(startPlayTrailersIntervallId)
    }

    componentDidUpdate(prevProps, prevState) {
        const { activeSelection, activeItem, selectionId, closeItemInformation, items } = this.props

        if (activeSelection !== prevProps.activeSelection) {
            if(activeSelection && activeItem && activeSelection !== selectionId) {
                closeItemInformation()
            }
        }

        if(prevProps.items !== items) {
            this.startPlayTrailers()
        }
    }

    arrayEquals(a, b) {
        return Array.isArray(a) &&
               Array.isArray(b) &&
               a.length === b.length &&
               a.every((val, index) => val === b[index])
    }

    setTrailerItemsInView(itemIndex, isInView) {
        const itemKey = itemIndex.toString()

        this.setState(prev => {
            const exists = prev.playTrailerIems.hasOwnProperty(itemKey)

            if(!exists || (isInView !== prev.playTrailerIems[itemKey].isInView)) {
                return {
                    ... prev,
                    playTrailerIems: {
                        ... prev.playTrailerIems,
                        [itemKey]: {
                            id: itemKey,
                            isInView: isInView,
                            play: exists && prev.playTrailerIems[itemKey].play && isInView ? true : false
                        }
                    }
                }
            } else {
                return null
            }
        })
    }

    playTrailer() {
        this.setState(prev => {
            const items = Object.values(prev.playTrailerIems)
            const itemsToPlay = items.filter(item => item.isInView && !item.play)
            const itemsToPlayLength = itemsToPlay.length


            if(itemsToPlayLength > 0) {
                const randIndex = this.randomIntFromInterval(0, itemsToPlayLength - 1)
                const itemToPlay = itemsToPlay[randIndex]

                return {
                    ... prev,
                    playTrailerIems: {
                        ... prev.playTrailerIems,
                        [itemToPlay.id] : {
                            ... itemToPlay,
                            play: true
                        }
                    }
                }
            } else {
                clearInterval(prev.startPlayTrailersIntervallId)

                return {
                    ...prev,
                    startPlayTrailersIntervallId: false
                }
            }
        })
    }


    startPlayTrailers() {
        this.setState(prev => {
            if(!prev.startPlayTrailersIntervallId) {
                const newPlayTrailersIntervallId = setInterval(this.playTrailer, this.playTrailerAfter)

                return {
                    ... prev,
                    startPlayTrailersIntervallId: newPlayTrailersIntervallId
                }
            } else {
                return null
            }
        })
    }

    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    render() {
        const { 
            items, 
            itemsData, 
            elbenwald,
            activeItem, 
            activeDetailsItem,
            itemOnClick,  
            closeItemInformation, 
            openItemDetails, 
            closeItemDetails, 
            displaySidebarRight, 
            displaySidebarRightSecond,
            activePerformance, 
            detailsStyling,
            performancePageOpen,
            onOpenPerformancePage,
            onClosePerformancePage,
            interscrollerAdvertisements,
            interscrollerWeischerAds,
            queryStringValues,
            ignoreAttributesForPerformanceFilter,
            overviewFilterIgnoreOnPerformances,
            movieInformationOrder,
            row,
            theme,
            isMobile,
            dayFilters,
            hiddenAttributes,
            posterStyling,
            translation,
            moviesRoutesData,
            additionalScrollName = '',
            currentDateActive,
            toggleMovieDatesOnMobileView,
            informationStyling,
            attributeStyling,
            gridCols,
            isConnectedFast
        } = this.props

        const { playTrailerIems } = this.state

        const eventOrigins = {
            poster:                 'Programmübersicht, Grid, Posterelement',
            information:            'Programmübersicht, Grid, Film Information',
            informationSlidebar:    'Programmübersicht, Grid, Film Information/rechte Slidebar',
            details:                'Programmübersicht, Grid, Film Details',
            detailsSlidebar:        'Programmübersicht, Grid, Film Details/rechte Slidebar',
            performance:            'Programmübersicht, Grid, Film Vorführung'
        }
        const integer = Math.ceil(items.length/6) >= 4 ? 6 : 3
        const { interscrollerId, interscrollerType, itemsWithInterscroller } = getItemsWithInterscroller(items, interscrollerWeischerAds, interscrollerAdvertisements, integer)

        return (
            <div className="grid-site-wrapper">
                <div className="overview-grid-trailer">
                    <GridTrailerItems
                        items={itemsWithInterscroller}
                        activeItem={activeItem}
                        playTrailerIems={playTrailerIems}
                        posterStyling={posterStyling}
                        attributeStyling={attributeStyling}
                        additionalScrollName={additionalScrollName}
                        itemsData={itemsData}
                        translation={translation}
                        itemOnClick={trackMovieInformationOpen(itemOnClick, eventOrigins.poster)}
                        movieInformationOrder={movieInformationOrder}
                        gridCols={gridCols}
                        isMobile={isMobile}
                        hiddenAttributes={hiddenAttributes}
                        interscrollerId={interscrollerId}
                        interscrollerType={interscrollerType}
                        interscrollerWeischerAds={interscrollerWeischerAds}
                        interscrollerAdvertisements={interscrollerAdvertisements}

                        isConnectedFast={isConnectedFast}
                        setTrailerItemsInView={this.setTrailerItemsInView}
                    />

                    <GridMovieInformation
                        informationStyling={informationStyling}
                        dayFilters={dayFilters}
                        additionalScrollName={additionalScrollName}
                        detailsStyling={detailsStyling}
                        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        activeItem={activeItem}
                        queryStringValues={queryStringValues}
                        isMobile={isMobile}
                        theme={theme}
                        attributeStyling={attributeStyling}
                        itemsData={itemsData}
                        elbenwald={elbenwald}
                        activeDetailsItem={activeDetailsItem}
                        displaySidebarRight={displaySidebarRight}
                        displaySidebarRightSecond={displaySidebarRightSecond}
                        closeItemInformation={closeItemInformation}
                        openItemDetails={openItemDetails}
                        closeItemDetails={closeItemDetails}
                        movieInformationOrder={movieInformationOrder}
                        toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                        currentDateActive = {currentDateActive}
                        row={row}
                        activePerformance={activePerformance}
                        translation={translation}
                        itemLink={getMovieLink(activeItem, moviesRoutesData, translation)}
                        eventOrigins={eventOrigins}
                        performancePageOpen={performancePageOpen}
                        onOpenPerformancePage={onOpenPerformancePage}
                        onClosePerformancePage={onClosePerformancePage}
                    />
                </div>
            </div>
        )
    }
}


export default hasToggleMovieDatesOnMobile(hasGridInformation(FilterResultsGridTrailer))